import { createApp } from 'vue'
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
//import axios from 'axios'
import VueCryptojs from 'vue-cryptojs'
import interceptorSetup from './interceptor'
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css'
import App from './App.vue'
import router from './router';
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
import { axiosTransporte, axiosBuffet } from './services/axiosInstances';

// const axiosInstance = axios.create({
//     withCredentials: false,
// });

const app = createApp(App);

app.use(VueSweetalert2);
app.use(VueCryptojs);
app.use(router);

// axiosInstance.defaults.baseURL = process.env.VUE_APP_API_BASEURL;
// axiosInstance.defaults.withCredentials = false;

app.config.globalProperties.$axios = { ...axiosTransporte };
app.config.globalProperties.$axiosBuffet = { ...axiosBuffet };

export default axiosTransporte;

app.use(VueKeycloakJs, {
    init: {
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: "S256",
    },

    logout: {
        redirectUri: process.env.VUE_APP_KEYCLOAK_LOGOUT_URL
    },
    
    config: {
        url: process.env.VUE_APP_KEYCLOAK_AUTH,
        realm: process.env.VUE_APP_KEYCLOAK_REALM,
        clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
        enablePkce: true,
    },

    onReady: (keycloak) => {
        //interceptar as requisicoes axios, incluindo o bearer token do keycloak no header 
        interceptorSetup(keycloak, [axiosTransporte, axiosBuffet]);

        app.mount('#app');
    }
});




